import { ConditionRepository } from '@/io/repository/ConditionRepository';
import { makeQueryKey } from '@/queries/Queries';
import { createSuspenseQuery } from '@/queries/utils/CreateSuspenseQuery.ts';

export class ConditionQueries {
  constructor(
    private readonly condition: ConditionRepository = new ConditionRepository(),
  ) {}

  /*******************************/
  /*********** QUERIES ***********/
  /*******************************/

  useCondition = createSuspenseQuery(
    'condition',
    patientId => makeQueryKey(patientId),
    async (patientId: string) => this.condition.getCondition(patientId),
  );
}
